import { css, keyframes } from "styled-components";

import { colorIsLight, lightenDarkenColor } from "Utilities/Colors/colorUtils";

const flashAnimation = (fromColor, toColor) => keyframes`
  from {
    background-color: ${fromColor};
  }
  to {
    background-color: ${toColor};
  }
`;

const flash = ({
  $isFlashing,
  $backgroundColor = "#ffffff00",
  $flashToColor = lightenDarkenColor(
    $backgroundColor,
    colorIsLight($backgroundColor) ? -60 : 60
  ),
}) =>
  $isFlashing
    ? css`
        animation: ${flashAnimation($backgroundColor, $flashToColor)} 0.5s
          ease-in-out infinite alternate;
      `
    : "";

/**
 * Generates CSS string for a flashing background color animation (for dynamic injection)
 * @param {Object} options - Configuration options
 * @param {string} options.selector - CSS selector for the element (e.g., '.my-element.flashing')
 * @param {string} options.color1 - Starting/ending background color
 * @param {string} options.color2 - Middle background color
 * @param {string} [options.borderRadius] - Optional border radius (e.g., '8px')
 * @param {string} [options.name='background-flash'] - Optional animation name
 * @returns {string} Complete CSS string with keyframes and class
 */
export const generateBackgroundFlashStyles = ({
  selector,
  color1,
  color2,
  borderRadius,
  name = "background-flash",
}) => {
  return `
    @keyframes ${name} {
      0%, 100% {
        background-color: ${color1};
      }
      50% {
        background-color: ${color2};
      }
    }

    ${selector} {
      animation: ${name} 1s ease-in-out infinite !important;${
        borderRadius ? `border-radius: ${borderRadius} !important;` : ""
      }
      background-image: none;
    }
  `;
};

export default flash;
